import React, { ReactNode } from "react";
import { TicketPriority } from "../../../../__generated__/api";
import Badge, { BadgeProps } from "../../../theme/badge/Badge";
import EditableLabel from "../editable-label/EditableLabel";
import Dropdown from "../../../theme/dropdown/Dropdown";

const PRIORITY_LABELS = {
    [TicketPriority.Critical]: "Critical",
    [TicketPriority.High]: "High",
    [TicketPriority.Medium]: "Medium",
    [TicketPriority.Low]: "Low",
};

const PRIORITY_TO_VARIENT: Record<TicketPriority, BadgeProps["variant"]> = {
    [TicketPriority.Critical]: "danger",
    [TicketPriority.High]: "warning",
    [TicketPriority.Medium]: "yield",
    [TicketPriority.Low]: "info",
};

export default function Priority({ ticketPriority, onChange }: {
    ticketPriority: TicketPriority;
    onChange?: (priority: TicketPriority) => void;
}) {
    let badge: ReactNode = PRIORITY_LABELS[ticketPriority];

    if (onChange) {
        const onDone = (done: (() => void)) => (
            <div>
                {Object.entries(PRIORITY_LABELS).map(([current, label]) => (
                    <Dropdown.Item
                        className="m-0 p3x-1 p3y-0"
                        key={current}
                        onClick={() => {
                            done();
                            onChange(current as TicketPriority);
                        }}
                    >
                        <Badge
                            className="m3y-0 m3x-0"
                            variant={PRIORITY_TO_VARIENT[current as TicketPriority]}
                            title={`Priority: ${PRIORITY_LABELS[current as TicketPriority]}`}
                        >
                            {label}
                        </Badge>
                    </Dropdown.Item>
                ))}
            </div>
        );
        badge = (
            <EditableLabel
                placement="bottom"
                menu={onDone}
            >
                {badge}
            </EditableLabel>
        );
    }
    return (
        <Badge
            variant={PRIORITY_TO_VARIENT[ticketPriority]}
            title={`Priority: ${PRIORITY_LABELS[ticketPriority]}`}
        >
            {badge}
        </Badge>
    );
}

Priority.defaultProps = {
    onChange: undefined,
};
